// Data loader utility to load data sources (matching Angular resolver pattern)
import { selectionData } from "../data/selectionData";

/**
 * Load data sources required for the ELISA Builder
 * This function mimics the Angular resolver pattern used in the original application
 * @returns {Promise<{selectionData: Array}>} Promise resolving to data sources
 */
export const loadDataSources = async () => {
  try {
    // In a real application, this might make API calls or load from different sources
    // For now, we're loading the static selection data that was converted from CSV
    return {
      selectionData: selectionData,
    };
  } catch (error) {
    throw new Error("Failed to load data sources");
  }
};
